import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'

import { cardGrid } from './CardGridReducer'

const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  cardGrid
});

export default rootReducer;